import script from "./CreatorChatMemberListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorChatMemberListComponent.vue?vue&type=script&setup=true&lang=js"

import "./CreatorChatMemberListComponent.vue?vue&type=style&index=0&id=ed557404&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed557404"]])

export default __exports__